export const CLEANER_RATING_BRAND_ORANGE = '#FF6A00';
export const CLEANER_RATING_STAR_EMOJI = '⭐️';
export const DEFAULT_CLEANER_RATING_UNRATED = 5;

/** Matches API default-5-until-reviewed when review count is known. */
export const normalizeCleanerAverageRating = (
  averageRating?: number | null,
  totalRatings?: number | null
): number => {
  if (totalRatings != null) {
    const total = Number(totalRatings) || 0;
    if (total <= 0) {
      return DEFAULT_CLEANER_RATING_UNRATED;
    }
    const value = Number(averageRating);
    return Number.isFinite(value) ? value : DEFAULT_CLEANER_RATING_UNRATED;
  }

  const value = Number(averageRating);
  if (Number.isFinite(value) && value > 0) {
    return value;
  }
  return DEFAULT_CLEANER_RATING_UNRATED;
};

/** One-decimal label; 5.0 when there are no reviews yet (or average unknown). */
export const formatCleanerListRating = (
  averageRating?: number | null,
  totalRatings?: number | null
): string => {
  const value = normalizeCleanerAverageRating(averageRating, totalRatings);
  return (Math.round(value * 10) / 10).toFixed(1);
};

/** Compact display label, e.g. ⭐️4.6 */
export const formatCompactCleanerRatingLabel = (
  averageRating?: number | null,
  totalRatings?: number | null
): string =>
  `${CLEANER_RATING_STAR_EMOJI}${formatCleanerListRating(
    averageRating,
    totalRatings
  )}`;

export const formatReviewRatingValue = (rating?: number | null): string => {
  const value = Number(rating);
  const normalized = Number.isFinite(value)
    ? value
    : DEFAULT_CLEANER_RATING_UNRATED;
  return (Math.round(normalized * 10) / 10).toFixed(1);
};

export const formatReviewRatingLabel = (rating?: number | null): string =>
  `${CLEANER_RATING_STAR_EMOJI}${formatReviewRatingValue(rating)}`;
